import { z } from 'zod';
import {
  storageOfferQuickFilterValues,
  storageOfferStatusValues,
  storageOffersProductTypeValues,
  storageOffersSortByValues,
} from 'src/apis/storage/mappings';
import {
  descSortDirectionSchema,
  formOptionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';
import { ssoOptionSchema } from 'src/pages/storage/components/sso-searchable-multi-select';

export function getStorageOffersPageParamsSchema() {
  return z.object({
    sortBy: z.enum(storageOffersSortByValues).default('OFFER_BUSINESS_ID'),
    sortDirection: descSortDirectionSchema,
    offerName: z.string().nullable().default(null),
    offerBusinessId: z
      .string()
      .regex(/^(STO-\d+)$/, '{label} must start from "STO-".')
      .nullable()
      .default(null),
    storageLocationId: z.preprocess(
      preprocessAsArray,
      z.array(formOptionSchema).default([])
    ),
    ssoOrganisationId: z.preprocess(
      preprocessAsArray,
      z.array(ssoOptionSchema).default([])
    ),
    typeOfProduct: z.preprocess(
      preprocessAsArray,
      z.array(z.enum(storageOffersProductTypeValues)).default([])
    ),
    productRuntimeStart: z.string().nullable().default(null),
    productRuntimeEnd: z.string().nullable().default(null),
    offerStatus: z.preprocess(
      preprocessAsArray,
      z.array(z.enum(storageOfferStatusValues)).default([])
    ),
    quickFilter: z
      .enum(storageOfferQuickFilterValues)
      .nullable()
      .default('ALL'),
    ...getPaginationSchema().shape,
  });
}
